import {
  REGISTER_EMAIL,
  REGISTER_EMAIL_SUCCESS,
  REGISTER_EMAIL_FAIL,

  ACTIVATE_TOKEN,
  ACTIVATE_TOKEN_SUCCESS,
  ACTIVATE_TOKEN_FAIL,

  GET_TOKEN_LINE,
  GET_TOKEN_LINE_SUCCESS,
  GET_TOKEN_LINE_FAIL,

  VERIFY_TOKEN_LINE,
  VERIFY_TOKEN_LINE_SUCCESS,
  VERIFY_TOKEN_LINE_FAIL,

  GET_TOKEN_LINE_MOBILE,
  GET_TOKEN_LINE_MOBILE_SUCCESS,
  GET_TOKEN_LINE_MOBILE_FAIL,

  VERIFY_TOKEN_LINE_MOBILE,
  VERIFY_TOKEN_LINE_MOBILE_SUCCESS,
  VERIFY_TOKEN_LINE_MOBILE_FAIL

} from '../actions'

/* register */
export const registeremailFetch = (registerEmail) => ({
  type: REGISTER_EMAIL,
  payload: { registerEmail }
})

export const registeremailFetchSuccess = (registerEmail) => ({
  type: REGISTER_EMAIL_SUCCESS,
  payload: { registerEmail }
})

export const registeremailFetchFail = (message) => ({
  type: REGISTER_EMAIL_FAIL,
  payload: { message }
})

/* activate */
export const activateTokenFetch = (activateToken) => ({
  type: ACTIVATE_TOKEN,
  payload: { activateToken }
})

export const activateTokenFetchSuccess = (activateToken) => ({
  type: ACTIVATE_TOKEN_SUCCESS,
  payload: { activateToken }
})

export const activateTokenFetchFail = (message) => ({
  type: ACTIVATE_TOKEN_FAIL,
  payload: { message }
})

/* get token line */
export const getTokenlineFetch = (getTokenline) => ({
  type: GET_TOKEN_LINE,
  payload: { getTokenline }
})

export const getTokenlineFetchSuccess = (getTokenline) => ({
  type: GET_TOKEN_LINE_SUCCESS,
  payload: { getTokenline }
})

export const getTokenlineFetchFail = (message) => ({
  type: GET_TOKEN_LINE_FAIL,
  payload: { message }
})

/* verify token line */
export const verifyTokenlineFetch = (verifyTokenline) => ({
  type: VERIFY_TOKEN_LINE,
  payload: { verifyTokenline }
})

export const verifyTokenlineFetchSuccess = (verifyTokenline) => ({
  type: VERIFY_TOKEN_LINE_SUCCESS,
  payload: { verifyTokenline }
})

export const verifyTokenlineFetchFail = (message) => ({
  type: VERIFY_TOKEN_LINE_FAIL,
  payload: { message }
})


/* get token lineMobile */
export const getTokenlineMobileFetch = (getTokenlineMobile) => ({
  type: GET_TOKEN_LINE_MOBILE,
  payload: { getTokenlineMobile }
})

export const getTokenlineMobileFetchSuccess = (getTokenlineMobile) => ({
  type: GET_TOKEN_LINE_MOBILE_SUCCESS,
  payload: { getTokenlineMobile }
})

export const getTokenlineMobileFetchFail = (message) => ({
  type: GET_TOKEN_LINE_MOBILE_FAIL,
  payload: { message }
})

/* verify token lineMobile */
export const verifyTokenlineMobileFetch = (verifyTokenlineMobile) => ({
  type: VERIFY_TOKEN_LINE_MOBILE,
  payload: { verifyTokenlineMobile }
})

export const verifyTokenlineMobileFetchSuccess = (verifyTokenlineMobile) => ({
  type: VERIFY_TOKEN_LINE_MOBILE_SUCCESS,
  payload: { verifyTokenlineMobile }
})

export const verifyTokenlineMobileFetchFail = (message) => ({
  type: VERIFY_TOKEN_LINE_MOBILE_FAIL,
  payload: { message }
})